import i18n from 'i18n'

const ShowSuccessMsgEntrance = () => {
  const isFrench = i18n.language.startsWith('fr')

  return (
    <div
      className='d-flex align-items-center justify-content-center px-3 py-10'
      style={{minHeight: '70vh'}}
    >
      <div className='card border-0 shadow-sm w-100' style={{maxWidth: '850px'}} aria-live='polite'>
        <div className='card-body text-center p-6 p-md-10'>
          <div
            className='d-inline-flex align-items-center justify-content-center rounded-circle bg-light-success mb-6'
            style={{width: '90px', height: '90px'}}
          >
            <i className='fas fa-check-circle text-success' style={{fontSize: '52px'}} />
          </div>

          <h4 className='fw-bold text-gray-900 mb-5'>
            {isFrench
              ? 'Merci pour votre préinscription au concours d’entrée de SWISS UMEF University - Campus de Dakar.'
              : 'Thank you for your pre-registration for the SWISS UMEF University – Dakar Campus Entrance Examination.'}
          </h4>

          <div className='fs-5 text-gray-700 lh-lg'>
            {isFrench ? (
              <>
                <p className='mb-4'>
                  Nous avons le plaisir de vous informer que votre compte e-Academy a été créé.
                  Celui-ci vous permettra d’accéder au concours d’entrée, au guide du candidat ainsi
                  qu’à l’ensemble des consignes nécessaires.
                </p>

                <p className='mb-4'>
                  Un e-mail de confirmation et d’activation vient de vous être envoyé. Nous vous
                  invitons à vérifier votre messagerie électronique ainsi que votre dossier de
                  courriers indésirables.
                </p>

                <p className='mb-4  text-end'>
                  Si vous n’avez pas reçu l’e-mail d’activation, merci de contacter le Service des
                  admissions par WhatsApp ou par e-mail en indiquant :
                  <ul>
                    <li>vos nom et prénom ;</li>
                    <li>votre date de naissance ;</li>
                    <li>votre pays de résidence ;</li>
                    <li>votre ville de résidence.</li>
                  </ul>
                </p>
                <p className='mb-4'>Notre équipe fera le nécessaire pour activer votre compte.</p>
                <p className='mb-4'>
                  Après avoir passé le concours, vous recevrez une notification officielle
                  concernant votre résultat et la suite de la procédure d’admission.
                </p>
                <p className='mb-4'>Nous vous souhaitons pleine réussite.</p>

                <p className='mb-0'>
                  Service des admissions
                  <br />
                  SWISS UMEF University - Campus de Dakar
                  <br />
                  admissions@swiss-umef.sn
                  <br />
                  +221 78 464 78 78
                  <br />
                  +221 71 030 41 41
                </p>
              </>
            ) : (
              <>
                <p className='mb-4'>
                  We are pleased to inform you that your e-Academy account has been created. This
                  account will allow you to access the entrance examination, the Candidate Guide,
                  and all the instructions required to complete the admission process.
                </p>

                <p className='mb-4'>
                  A confirmation and account activation email has just been sent to you. Please
                  check your inbox as well as your spam or junk mail folder.
                </p>

                <p className='mb-4 text-end'>
                  If you have not received the activation email, please contact the Admissions
                  Office via WhatsApp or email and provide the following information:
                  <ul>
                    <li>Your full name;</li>
                    <li>Your date of birth;</li>
                    <li>Your country of residence;</li>
                    <li>Your city of residence.</li>
                  </ul>
                </p>
                <p className='mb-4'>
                  Our team will take the necessary steps to activate your account.
                </p>
                <p className='mb-4'>
                  Once you have completed the entrance examination, you will receive an official
                  notification regarding your results and the next steps in the admission process.
                </p>
                <p className='mb-4'>We wish you every success.</p>

                <p className='mb-0'>
                  Admissions Office
                  <br />
                  SWISS UMEF University – Dakar Campus
                  <br />
                  admissions@swiss-umef.sn
                  <br />
                  +221 78 464 78 78
                  <br />
                  +221 71 030 41 41
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShowSuccessMsgEntrance
